<template>
	<div style="width: 320px">
		<div v-if="!isRecording" style="margin-left: 30px" class="image-container">
			<img style="width: 180px;height: 180px" :src="require(`@/assets/picture/icon/play.png`)" alt="start"
				@click="startRecording">
			<div @click="startRecording" class="overlay" style="color:blue">
				<p>点击开始录音</p>
			</div>
		</div>
		<div v-if="isRecording" class="image-container">
			<el-row>

        <div style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;padding-top:20px;">
          剩余时间:<span style="color: red">{{ remainingMinutes }}:{{ remainingSeconds }}</span><br>
          <img style="width: 180px;height: 180px;margin-left:50px;" v-if="!hasRecord"
               :src="require(`@/assets/picture/icon/recording.gif`)" alt="microphone">
          <img style="width: 180px;height: 180px;margin-left:50px;" v-if="hasRecord"
               :src="require(`@/assets/picture/icon/stop.png`)" alt="microphone">

        </div>

        <!--				<div style="height:100px;width:300px;" class="overlay" ref="recWave"></div>-->
      </el-row>
			<el-row style="height: 80px">
				<audio v-if="hasRecord" ref="recordPlayer" :src="recordUrl" controls @pause="recordPause"
					@play="recordPlay"></audio>
			</el-row>
			<el-row>
				<el-button type="primary" v-if="!hasRecord" @click="generateRecording" style="margin-left: 90px">录音结束
				</el-button>
				<el-button type="warning" v-if="hasRecord" @click="reRecording">重新录音</el-button>
				<el-button type="success" v-if="hasRecord" @click="submitRecord">提交录音</el-button>
				<el-button type="danger" v-if="hasRecord" @click="giveUpRecording">放弃录音</el-button>
			</el-row>
		</div>


		<!--    <el-button v-if="!isRecording" type="primary" size="large" @click="startRecording"></el-button>-->

	</div>
</template>

<script>
import {
  ref
} from "vue";
import Recorder from "recorder-core";
import 'recorder-core/src/engine/mp3';
import "recorder-core/src/engine/mp3-engine";

const isRecording = ref(false);
const hasRecord = ref(false);
const recordPlayer = ref(new Audio());
const recordUrl = ref('');
const remainingTime = ref(120); // 2小时 = 7200秒
const remainingMinutes = ref("02");
const remainingSeconds = ref("00");
let intervalId = null;

function getTimeString(number) {
  if (number < 10) {
    return "0" + number;
  } else {
    return number;
  }
}


	export default {
		name: "recordComponent",
		data() {
			return {
				isRecording: isRecording,
				hasRecord: hasRecord,
				recordPlayer: recordPlayer,
				recordUrl: recordUrl,
				remainingMinutes: remainingMinutes,
				remainingSeconds: remainingSeconds
			}
		},
		mounted() {
			if (intervalId) {
				clearInterval(intervalId);
			}
			this.startInterval();
		},
		methods: {
      startRecording() {
        if (intervalId) {
          clearInterval(intervalId);
        }
        this.startInterval();
        isRecording.value = true;
        hasRecord.value = false;
        this.rec = Recorder({
          type: "mp3" //录音格式，可以换成wav等其他格式
          ,
          sampleRate: 16000 //录音的采样率，越大细节越丰富越细腻
          ,
          bitRate: 16 //录音的比特率，越大音质越好
          ,
          channelCount: 1,
          // onProcess: (buffers, powerLevel, bufferDuration, bufferSampleRate) => {
          //   //录音实时回调，大约1秒调用12次本回调
          //   //可实时绘制波形，实时上传（发送）数据
          //   // if (this.wave) this.wave.input(buffers[buffers.length - 1], powerLevel,
          //   //     bufferSampleRate);
          // },
          audioTrackSet: "echoCancellation",
        });
        this.rec.open(() => {
          // console.log("录音已打开");
          // if (this.$refs.recWave) { //创建音频可视化图形绘制对象
          //   this.wave = Recorder.WaveView({
          //     elem: this.$refs.recWave
          //   });
          // }
          this.rec.start();
        }, (msg, isUserNotAllow) => {
          //用户拒绝了录音权限，或者浏览器不支持录音
          console.log((isUserNotAllow ? "UserNotAllow，" : "") + "无法录音:" + msg);
        });
      },
      stopRecording() {
        if (intervalId) {
          clearInterval(intervalId);
          remainingTime.value = 120;
        }
        if (!this.rec) {
          return
        }
        this.rec.stop(() => {
          this.rec.close(); //关闭录音，释放录音资源，当然可以不释放，后面可以连续调用start
          this.rec = null;
        }, (err) => {
          console.error("结束录音出错：" + err);
          this.rec.close(); //关闭录音，释放录音资源，当然可以不释放，后面可以连续调用start
          this.rec = null;
        })
      },
      generateRecording() {
        if (!this.rec) {
          return
        }
        this.rec.stop((blob) => {
          //blob就是我们要的录音文件对象，可以上传，或者本地播放
          this.recBlob = blob;
          //简单利用URL生成本地文件地址，此地址只能本地使用，比如赋值给audio.src进行播放，赋值给a.href然后a.click()进行下载（a需提供download="xxx.mp3"属性）
          // console.log("录音成功", blob, localUrl, "时长:" + duration + "ms");
          recordUrl.value = URL.createObjectURL(blob);
          // this.upload(blob);//把blob文件上传到服务器
          hasRecord.value = true;
          this.rec.close(); //关闭录音，释放录音资源，当然可以不释放，后面可以连续调用start
          this.rec = null;
        }, (err) => {
          console.error("结束录音出错：" + err);
          this.rec.close(); //关闭录音，释放录音资源，当然可以不释放，后面可以连续调用start
          this.rec = null;
        });
      },
      recordPlay() {
        recordPlayer.value.play();
      },
      recordPause() {
        recordPlayer.value.pause();
      },
      reRecording() {
        setTimeout(function () {
          URL.revokeObjectURL(recordUrl.value)
        }, 5000);
        if (intervalId) {
          clearInterval(intervalId);
          remainingTime.value = 120;
        }
        this.startRecording();
      },
      submitRecord() {
        setTimeout(function () {
          URL.revokeObjectURL(recordUrl.value)
        }, 5000);
        isRecording.value = false;
        hasRecord.value = false;
        if (intervalId) {
          clearInterval(intervalId);
          remainingTime.value = 120;
        }
        this.$emit('submitRecord:value', this.recBlob);
      },
      giveUpRecording() {
        setTimeout(function () {
          URL.revokeObjectURL(recordUrl.value)
        }, 5000);
        isRecording.value = false;
        hasRecord.value = false;
        if (intervalId) {
          clearInterval(intervalId);
          remainingTime.value = 120;
        }
        this.$emit('submitRecord:value', null);
      },
      startInterval() {
        intervalId = setInterval(() => {
          if (remainingTime.value > 0) {
            remainingTime.value -= 1;
            remainingMinutes.value = getTimeString(Math.floor((remainingTime.value % 3600) / 60));
            remainingSeconds.value = getTimeString(Math.floor(remainingTime.value % 60));
          } else {
            this.stopRecording();
            this.submitRecord();
          }
        }, 1000);
      }
    }
	}
</script>

<style scoped>
	.image-container {
		position: relative;
		display: inline-block;
		/* 或者其他适合你布局的定位 */
	}

	.image-container .overlay {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		/*background-color: rgba(0, 0, 0, 0.5); !* 半透明背景 *!*/
		display: flex;
		justify-content: center;
		align-items: center;
		color: white;
	}
</style>
